/* FEAT-002: ring listing quick view (sections/vdb-setting-plp.liquid + snippets/vdb-ring-quick-view.liquid).
   One delegated click listener per <vdbrc-quick-view>, so cards added by infinite scroll or a filter reload work too. */
(function () {
  if (customElements.get('vdbrc-quick-view')) return;

  var MAX_MEDIA = 8;
  var FADE_MS = 300;
  var OVERLAY_GUARD_MS = 400;
  var CLOSE_GUARD_MS = 250;
  /* Ring Size sent to the cart: the first size in the ring page's list (sections/setting-pdp.liquid:555, sizes 3 … 12). */
  var FIRST_RING_SIZE = '3';
  var productCache = new Map();
  var SETTING_3D_MATERIALS = [
    {
      pmat: {
        yellow_gold: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-yellow.pmat',
        white_gold: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-white.pmat',
        rose_gold: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-rose.pmat',
      },
      dmat: {
        default: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-dmat.dmat',
        round: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Round.dmat',
        oval: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Oval.dmat',
        pear: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Pear.dmat',
        'e cushion': 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Elongated-Cushion.dmat',
        cushion: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Cushion.dmat',
        emerald: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Emerald.dmat',
        princess: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Round.dmat',
        marquise: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Round.dmat',
        radiant: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Round.dmat',
        asscher: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Asscher.dmat?v=1780040804',
        'long cushion': 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Elongated-Cushion.dmat',
        heart: 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heart.dmat',
        'square cushion': 'https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Square-Cushion.dmat',
      },
      vjson: 'https://all-demos.s3.us-east-1.amazonaws.com/3D_Assets/Antique-Cut/CADs/Antique-Imagesss.vjson',
    },
  ];

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        reject(new Error('Couldn’t load the 3D model.'));
        return;
      }
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing && existing.getAttribute('data-vdbrc-failed') === 'true') {
        existing.remove();
        existing = null;
      }
      if (existing && existing.getAttribute('data-vdbrc-loaded') === 'true') {
        resolve();
        return;
      }
      if (existing) {
        existing.addEventListener('load', function () { resolve(); }, { once: true });
        existing.addEventListener('error', function () { reject(new Error('Couldn’t load the 3D model.')); }, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = function () {
        script.setAttribute('data-vdbrc-loaded', 'true');
        resolve();
      };
      script.onerror = function () {
        script.setAttribute('data-vdbrc-failed', 'true');
        reject(new Error('Couldn’t load the 3D model.'));
      };
      document.head.appendChild(script);
    });
  }

  function optionSelected(product, label) {
    var options = (product && product.option_data) || [];
    var match = options.find(function (option) {
      return norm(option.label).toLowerCase() === label;
    });
    return match ? norm(match.selected).toLowerCase() : '';
  }

  function metalPair(metal, color) {
    if (metal.indexOf('platinum') !== -1) return { head: 'white_gold', shank: 'white_gold' };
    if (color.indexOf('two tone yellow') !== -1 || color.indexOf('w+y') !== -1 || color.indexOf('white/yellow') !== -1) {
      return { head: 'white_gold', shank: 'yellow_gold' };
    }
    if (color.indexOf('two tone rose') !== -1 || color.indexOf('w+r') !== -1 || color.indexOf('white/rose') !== -1) {
      return { head: 'white_gold', shank: 'rose_gold' };
    }
    if (color.indexOf('rose') !== -1) return { head: 'rose_gold', shank: 'rose_gold' };
    if (color.indexOf('yellow') !== -1) return { head: 'yellow_gold', shank: 'yellow_gold' };
    return { head: 'white_gold', shank: 'white_gold' };
  }

  function parseCaratGlbs(value) {
    return String(value || '').split(',').map(function (item) {
      var parts = item.split('|');
      if (parts.length < 3) return null;
      return {
        carat: parseFloat(parts[0].replace(/ct/i, '')),
        head: parts[1],
        shank: parts[2],
      };
    }).filter(function (item) {
      return item && item.head && item.shank && !isNaN(item.carat);
    });
  }

  function pickSettingGlbs(product) {
    var model = (product && product.product_data) || {};
    var pairs = parseCaratGlbs(model.carat_glbs);
    var selectedCarat = parseFloat(String(optionSelected(product, 'carat size')).replace(/ct/i, ''));
    if (isNaN(selectedCarat) && typeof window.vdbrcSelectedCarat === 'number') selectedCarat = window.vdbrcSelectedCarat;
    if (pairs.length && !isNaN(selectedCarat)) {
      var nearest = pairs.slice().sort(function (a, b) {
        return Math.abs(a.carat - selectedCarat) - Math.abs(b.carat - selectedCarat);
      })[0];
      if (nearest) return { head: nearest.head, shank: nearest.shank };
    }
    if (model.head_glb && model.shank_glb) return { head: model.head_glb, shank: model.shank_glb };
    var fallback = pairs.find(function (item) { return item.carat === 1; }) || pairs[0];
    return fallback ? { head: fallback.head, shank: fallback.shank } : null;
  }

  function buildThreeDMedia(product, glbs) {
    var materials = (window.three_d_static_data || SETTING_3D_MATERIALS)[0];
    var colors = metalPair(optionSelected(product, 'metal'), optionSelected(product, 'color'));
    var shape = optionSelected(product, 'shape');
    var dmat = (materials.dmat && (materials.dmat[shape] || materials.dmat.default)) || '';
    return [
      { option_type: 'model', option_value: glbs.head, option_identifier: 'head' },
      { option_type: 'model', option_value: glbs.shank, option_identifier: 'shank' },
      { option_type: 'material', option_value: materials.pmat[colors.head], option_identifier: 'metal-top,metal- top,Metal 02,Metal 04,head,EW' },
      { option_type: 'material', option_value: materials.pmat[colors.shank], option_identifier: 'metal-shank,metal-shape,shank' },
      { option_type: 'material', option_value: dmat, option_identifier: 'mainstone- marquise, mainstone-RADIANT, mainstone-asscher, mainstone-cushion, mainstone-emerald, mainstone-heart, mainstone-long cushion , mainstone-marquise, mainstone-oval, mainstone-ovel, mainstone-pear, mainstone-princess, mainstone-radian, mainstone-radiant, mainstone-round, mainstone-sq cushion, mainstone-square cushion, mainstone-square-cushion, sidestone-emerald, sidestone-marquise, sidestone-round, sidestone-round.001, shanklsidestone-round, shanksidestone-baguette, shanksidestone-marquise, shanksidestone-round, sidestone-baguette' },
    ];
  }

  /* Resolves after init() has finished painting, not when viewerLoaded flips on mid-load. */
  function waitForViewerPaint() {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      (function tick() {
        var loader = document.getElementById('webgl_vdb_setting_canvas_loader');
        var ready = window.player && window.player.viewerLoaded && window.player.viewer;
        var loaderHidden = !loader || loader.style.display === 'none';
        if (ready && loaderHidden) {
          resolve();
          return;
        }
        if (Date.now() - started > 20000) {
          reject(new Error('Couldn’t load the 3D model.'));
          return;
        }
        setTimeout(tick, 100);
      })();
    });
  }

  /* A second init on the same canvas keeps the first WebGL context, so the next ring paints blank. */
  function replaceThreeDCanvas() {
    var old = document.getElementById('webgl_vdb_canvas');
    if (!old || !old.parentNode) return;
    var fresh = document.createElement('canvas');
    fresh.id = 'webgl_vdb_canvas';
    fresh.className = old.className;
    fresh.setAttribute('data-engine', old.getAttribute('data-engine') || 'three.js r141');
    old.removeAttribute('id');
    old.parentNode.insertBefore(fresh, old);
    old.remove();
  }

  function disposeThreeDViewer() {
    var viewer = window.player && window.player.viewer;
    if (!viewer) return;
    try {
      if (typeof viewer.dispose === 'function') viewer.dispose();
    } catch (e) { /* the next canvas gets a new viewer */ }
    if (typeof window.player.resetAllVariables === 'function') window.player.resetAllVariables();
  }

  var renderChain = Promise.resolve();
  function renderSettingModel(product, glbs) {
    var media = buildThreeDMedia(product, glbs);
    var run = renderChain.catch(function () {}).then(async function () {
      if (!window.player) throw new Error('Couldn’t load the 3D model.');
      disposeThreeDViewer();
      replaceThreeDCanvas();
      await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      var canvas = document.getElementById('webgl_vdb_canvas');
      if (canvas && !canvas.offsetWidth) {
        await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      }
      window.player.init('webgl_vdb_canvas', media);
      await waitForViewerPaint();
    });
    renderChain = run;
    return run;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    var p = fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js?vdbrc_qv=1', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
    productCache.set(handle, p);
    p.catch(function () {
      if (productCache.get(handle) === p) productCache.delete(handle);
    });
    return p;
  }

  function norm(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  /* "$630.00" / "Rs. 61,400.00" / "₹ 61,400.00" / "$630" / "80,00 €" → symbol, integer, decimals */
  function splitPrice(text) {
    var t = norm(text);
    var m = /^([^\d]*)([\d][\d.,\s]*?)([.,]\d{2})?(\s*[^\d]*)$/.exec(t);
    if (!m) return { symbol: '', int: t, dec: '' };
    return { symbol: m[1], int: m[2], dec: (m[3] || '') + (m[4] || '') };
  }

  function settingModel(product) {
    if (!product) return null;
    var model = product.product_data;
    if (model && (model.price != null || model.compare_at_price != null)) return model;
    return product;
  }

  function formatSettingMoney(amount, withCurrencyCode) {
    if (typeof handlePriceData !== 'function') return '';
    var currency = typeof shop_currency !== 'undefined' ? shop_currency : 'USD';
    var formatted = handlePriceData(currency, amount, false);
    if (withCurrencyCode && typeof currency_code_enabled !== 'undefined' && currency_code_enabled && typeof market_currency !== 'undefined' && market_currency) {
      return formatted + ' ' + market_currency;
    }
    return formatted;
  }

  function formatSaveAmount(amount) {
    var formatted = formatSettingMoney(amount, false);
    if (!formatted) return '';
    var label = typeof vdbrcSaveLabel === 'string' ? vdbrcSaveLabel : 'Save __AMOUNT__';
    return label.replace('__AMOUNT__', formatted);
  }

  function textFromHtml(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    doc.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(' ');
    });
    doc.querySelectorAll('p, li, div').forEach(function (el) {
      el.append(' ');
    });
    return norm(doc.body.textContent);
  }

  function sanitizeHtml(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    doc.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach(function (el) {
      el.remove();
    });
    doc.querySelectorAll('*').forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) {
        if (/^on/i.test(a.name) || /^\s*javascript:/i.test(a.value)) el.removeAttribute(a.name);
      });
    });
    return doc.body.firstChild.innerHTML;
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  class VdbrcQuickView extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog.vdbrc-qv');
      if (!this.dialog) return;
      this.state = 'closed';
      this.renderToken = 0;
      this.abort = new AbortController();
      var signal = this.abort.signal;
      this.mqDesktop = window.matchMedia('(min-width: 990px)');

      /* Capture phase: runs before the page's own click handlers (card links, filters). */
      window.addEventListener('click', this.onClickCapture.bind(this), { signal: signal, capture: true });
      document.addEventListener('click', this.onDocumentClick.bind(this), { signal: signal });
      this.dialog.addEventListener('pointerdown', this.onDialogPointerDown.bind(this), { signal: signal });
      /* A click listener on the overlay itself makes WebKit treat it as a tap target, so taps on it are not
         moved to a nearby link in the box. The dialog-level handler does the closing. */
      var overlay = this.dialog.querySelector('[data-qv-overlay]');
      if (overlay) overlay.addEventListener('click', function () {}, { signal: signal });
      this.dialog.addEventListener('click', this.onDialogClick.bind(this), { signal: signal });
      this.dialog.addEventListener('keydown', this.onKeydown.bind(this), { signal: signal });
      this.dialog.addEventListener('cancel', this.onCancel.bind(this), { signal: signal });
      this.dialog.addEventListener('close', this.onNativeClose.bind(this), { signal: signal });
      this.mqDesktop.addEventListener('change', this.placeMediaButtons.bind(this), { signal: signal });
      var gallery = this.dialog.querySelector('[data-qv-gallery]');
      gallery.addEventListener('scroll', this.onGalleryScroll.bind(this), { signal: signal, passive: true });
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.dialog && this.dialog.open) this.finishClose(false);
    }

    inMySection(el) {
      var mine = this.closest('.shopify-section');
      var theirs = el.closest('.shopify-section');
      return !mine || mine === theirs;
    }

    /* The 2nd click of a double tap / Enter+tap must not act. WebKit even re-targets that tap to the nearest
       clickable element in the box (touch adjustment). So: swallow every click in the guard window after
       opening (any target), any click outside the popup while it is open, and clicks on this section just
       after it closed. */
    onClickCapture(event) {
      var t = event.target;
      if (!event.isTrusted || !t || !t.closest) return;
      var now = performance.now();
      var inDialog = this.dialog.contains(t);
      var inGuard = this.state === 'open' && now - this.openedAt < OVERLAY_GUARD_MS;
      var outsideWhileOpen = this.state !== 'closed' && !inDialog;
      var justClosed = this.state === 'closed' && now < (this.suppressUntil || 0) && !inDialog && this.inMySection(t);
      /* Only real user clicks are held back; scripted clicks (filters, other code) always pass. */
      if (!inGuard && !outsideWhileOpen && !justClosed) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    onDialogPointerDown(event) {
      this.downAt = performance.now();
      this.downOnOverlay = !!(event.target.closest('[data-qv-overlay]') || event.target === this.dialog);
      if (event.target.closest && event.target.closest('[data-qv-select]')) this.applySelectUrl();
    }

    /* Overlay closes only for a press that started after the guard window (not the 2nd tap of a double tap). */
    overlayCloseAllowed() {
      var guardEnd = this.openedAt + OVERLAY_GUARD_MS;
      if (performance.now() < guardEnd) return false;
      if (typeof this.downAt === 'number' && this.downAt >= this.openedAt && this.downAt < guardEnd) return false;
      if (typeof this.downAt === 'number' && this.downAt >= this.openedAt && !this.downOnOverlay) return false;
      return true;
    }

    onDocumentClick(event) {
      var trigger = event.target.closest && event.target.closest('.vdbrc-qv__trigger');
      if (!trigger || !this.inMySection(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.state !== 'closed') return;
      var card = trigger.closest('.vdbrc_product_card');
      if (!card) return;
      this.open(trigger, card);
    }

    /* ---------- open / close ---------- */
    open(trigger, card) {
      var handle = card.getAttribute('data-product-handle');
      if (!handle) return;
      this.state = 'open';
      this.trigger = trigger;
      this.handle = handle;
      this.openedAt = performance.now();
      this.downAt = null;

      this.fillStatic(card, handle);
      this.lockScroll();
      this.dialog.classList.remove('is-closing');
      this.dialog.showModal();
      var close = this.dialog.querySelector('[data-qv-close]');
      if (close) close.focus({ preventScroll: true });
      this.loadProduct(handle);
    }

    close() {
      if (this.state !== 'open') return;
      this.state = 'closing';
      this.dialog.classList.add('is-closing');
      var self = this;
      this.closeTimer = setTimeout(function () {
        self.finishClose(true);
      }, FADE_MS);
    }

    finishClose(restoreFocus) {
      clearTimeout(this.closeTimer);
      if (this.dialog.open) this.dialog.close();
      this.cleanup(restoreFocus);
    }

    cleanup(restoreFocus) {
      if (this.state === 'closed') return;
      this.hideThreeD();
      this.state = 'closed';
      this.suppressUntil = performance.now() + CLOSE_GUARD_MS;
      this.renderToken++;
      this.dialog.classList.remove('is-closing');
      this.dialog.querySelectorAll('video').forEach(function (v) {
        v.pause();
      });
      this.unlockScroll();
      if (restoreFocus && this.trigger && this.trigger.isConnected) {
        this.trigger.focus({ preventScroll: true });
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    /* Chrome can close a modal dialog without 'cancel' (second quick Esc): clean up anyway. */
    onNativeClose() {
      if (this.state !== 'closed') {
        clearTimeout(this.closeTimer);
        this.cleanup(true);
      }
    }

    onDialogClick(event) {
      var t = event.target;
      if (t.closest('[data-qv-close]')) {
        this.close();
        return;
      }
      if (t.closest('[data-qv-overlay]') || t === this.dialog) {
        if (!this.overlayCloseAllowed()) return;
        this.close();
        return;
      }
      if (t.closest('[data-qv-cart]')) {
        this.addToCart(t.closest('[data-qv-cart]'));
        return;
      }
      if (t.closest('[data-qv-read-more]')) {
        this.openDescription();
        return;
      }
      var head = t.closest('[data-qv-acc-head]');
      if (head) {
        this.toggleAcc(head);
        return;
      }
      var nav = t.closest('[data-qv-nav]');
      if (nav) {
        this.slide(nav.getAttribute('data-qv-nav') === 'next' ? 1 : -1);
        return;
      }
      var tab = t.closest('[data-qv-tab]');
      if (tab) {
        this.goToKind(tab.getAttribute('data-qv-tab'));
        return;
      }
      var play = t.closest('[data-qv-play]');
      if (play) {
        var tile = play.closest('.vdbrc-qv__tile');
        var video = tile && tile.querySelector('video');
        if (video) {
          tile.classList.add('is-playing');
          video.setAttribute('controls', '');
          video.play().catch(function () {});
        }
        return;
      }
      var retry = t.closest('[data-qv-retry]');
      if (retry) this.loadProduct(this.handle);
    }

    onKeydown(event) {
      if (event.key !== 'Tab') return;
      var box = this.dialog.querySelector('.vdbrc-qv__box');
      var items = Array.prototype.filter.call(
        box.querySelectorAll('a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])'),
        function (el) {
          if (el.closest('[hidden]')) return false;
          var r = el.getBoundingClientRect();
          return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
        }
      );
      if (!items.length) return;
      event.preventDefault();
      var i = items.indexOf(document.activeElement);
      var next = event.shiftKey ? (i <= 0 ? items.length - 1 : i - 1) : i === -1 || i === items.length - 1 ? 0 : i + 1;
      items[next].focus();
    }

    /* ---------- scroll lock (theme's own body.overflow-hidden, with scrollbar padding) ---------- */
    lockScroll() {
      this.addedLock = !document.body.classList.contains('overflow-hidden');
      this.savedScroll = window.scrollY;
      if (this.addedLock) document.body.classList.add('overflow-hidden');
    }

    unlockScroll() {
      if (this.addedLock) document.body.classList.remove('overflow-hidden');
      this.addedLock = false;
      if (typeof this.savedScroll === 'number' && Math.abs(window.scrollY - this.savedScroll) > 1) {
        window.scrollTo(0, this.savedScroll);
      }
    }

    /* ---------- content ---------- */
    q(sel) {
      return this.dialog.querySelector(sel);
    }

    applySelectUrl() {
      var select = this.q('[data-qv-select]');
      if (!select || !this.handle || typeof window.vdbrcSettingSelectUrl !== 'function') return;
      select.setAttribute('href', window.vdbrcSettingSelectUrl(this.handle));
    }

    applyComparePrice(handle) {
      var self = this;
      var cached = typeof window.vdbrcSettingData === 'function' ? window.vdbrcSettingData(handle) : null;
      var model = settingModel(cached);
      if (model && model.price != null && model.compare_at_price != null) {
        this.paintCompare(model);
        return;
      }
      this.paintCompare(null);
      if (typeof window.vdbrcSettingPriceData !== 'function') return;
      window.vdbrcSettingPriceData(handle).then(function (product) {
        if (!product || self.handle !== handle || self.state !== 'open') return;
        self.paintCompare(settingModel(product));
      }).catch(function () {});
    }

    paintCompare(model) {
      var row = this.q('[data-qv-price-row]');
      var compareEl = this.q('[data-qv-compare]');
      var saveEl = this.q('[data-qv-save]');
      if (!row || !compareEl || !saveEl) return;

      compareEl.hidden = true;
      compareEl.textContent = '';
      saveEl.hidden = true;
      saveEl.textContent = '';
      row.classList.remove('is-on-sale');

      if (!model) return;
      var sale = parseFloat(model.price);
      var compare = parseFloat(model.compare_at_price);
      if (!Number.isFinite(sale) || !Number.isFinite(compare) || compare <= sale) return;

      var compareText = formatSettingMoney(compare, true);
      var saveText = formatSaveAmount(compare - sale);
      if (!compareText || !saveText) return;

      compareEl.textContent = compareText;
      saveEl.textContent = saveText;
      compareEl.hidden = false;
      saveEl.hidden = false;
      row.classList.add('is-on-sale');
    }

    fillStatic(card, handle) {
      var titleEl = card.querySelector('.vdbrc_select_setting_product');
      var priceEl = card.querySelector('.vdbrc_product_price');
      this.q('[data-qv-title]').textContent = norm(titleEl && titleEl.textContent);

      var price = this.q('[data-qv-price]');
      price.textContent = '';
      var parts = splitPrice(priceEl && priceEl.textContent);
      [['symbol', parts.symbol], ['int', parts.int], ['dec', parts.dec]].forEach(function (p) {
        if (!p[1]) return;
        var s = document.createElement('span');
        s.className = 'vdbrc-qv__price-' + p[0];
        s.textContent = p[1];
        price.appendChild(s);
      });
      this.applyComparePrice(handle);

      this.hideThreeD();
      this.q('[data-qv-desc]').textContent = '';
      this.q('[data-qv-desc-full]').innerHTML = '';
      this.q('[data-qv-gallery]').innerHTML = '';
      this.q('[data-qv-slider-ui]').innerHTML = '';
      this.q('[data-qv-gallery]').scrollLeft = 0;
      this.dialog.querySelectorAll('.vdbrc-qv__body, .vdbrc-qv__info, .vdbrc-qv__media').forEach(function (el) {
        el.scrollTop = 0;
      });
      this.dialog.querySelectorAll('[data-qv-acc-head]').forEach(function (h) {
        h.setAttribute('aria-expanded', 'false');
        var b = document.getElementById(h.getAttribute('aria-controls'));
        if (b) b.hidden = true;
      });

      this.applySelectUrl();
      this.q('[data-qv-studio]').setAttribute('href', window.vdbrcSettingProductUrl(handle));

      var cart = this.q('[data-qv-cart]');
      var stoneSelected = typeof vdbrcHasSelectedStone === 'function' && vdbrcHasSelectedStone();
      cart.hidden = stoneSelected;
      cart.disabled = false;
      cart.removeAttribute('aria-busy');
      cart.textContent = 'Add to cart';
      var err = this.q('[data-qv-error]');
      err.hidden = true;
      err.textContent = '';
    }

    loadProduct(handle) {
      var token = ++this.renderToken;
      var self = this;
      this.dialog.classList.add('is-loading');
      this.q('[data-qv-loading]').innerHTML = '<div class="vdbrc-qv__spinner"></div>';
      fetchProduct(handle).then(
        function (product) {
          if (token !== self.renderToken || self.state !== 'open') return;
          self.renderProduct(product);
          self.dialog.classList.remove('is-loading');
        },
        function () {
          if (token !== self.renderToken || self.state !== 'open') return;
          self.q('[data-qv-loading]').innerHTML =
            '<button type="button" class="vdbrc-qv__retry" data-qv-retry>Couldn’t load photos. Try again</button>';
        }
      );
    }

    renderProduct(product) {
      var desc = product.description || '';
      this.q('[data-qv-desc]').textContent = textFromHtml(desc);
      this.q('[data-qv-desc-full]').innerHTML = sanitizeHtml(desc);

      var media = (product.media || []).filter(function (m) { return m.media_type !== 'external_video'; }).slice(0, MAX_MEDIA);
      var gallery = this.q('[data-qv-gallery]');
      var html = '';
      var alt = (product.title || '').replace(/"/g, '&quot;');
      this.parkThreeDStage();
      media.forEach(function (m, i) {
        var kind = m.media_type === 'image' ? 'image' : 'video';
        html += '<div class="vdbrc-qv__tile" data-kind="' + kind + '">';
        if (m.media_type === 'video' && m.sources && m.sources.length) {
          var src = (m.sources.find(function (s) { return /mp4/.test(s.mime_type || s.format || ''); }) || m.sources[0]).url;
          var poster = m.preview_image ? imgUrl(m.preview_image.src, 684) : '';
          html +=
            '<video playsinline muted loop preload="none" poster="' + poster + '"><source src="' + src + '"></video>' +
            '<button type="button" class="vdbrc-qv__play" data-qv-play aria-label="Play video"><img src="' +
            this.dataset.iconPlay + '" alt="" width="20" height="20"></button>';
        } else {
          var s = m.src || (m.preview_image && m.preview_image.src);
          html +=
            '<img src="' + imgUrl(s, 684) + '" alt="' + (m.alt || alt).replace(/"/g, '&quot;') + '" width="342" height="342"' +
            (i === 0 ? '' : ' loading="lazy"') + '>';
        }
        html += '</div>';
      }, this);
      gallery.innerHTML = html;

      var first = gallery.firstElementChild;
      if (first && (product.tags || []).some(function (t) { return String(t).toLowerCase() === 'best-seller'; })) {
        first.insertAdjacentHTML('beforeend', '<span class="vdbrc-qv__tag">Best Seller</span>');
      }

      if (this.toProduct) this.toProduct.remove();
      /* 3D icon on the media (desktop: on tile 1; mobile: fixed on the slider) */
      this.toProduct = document.createElement('a');
      this.toProduct.className = 'vdbrc-qv__to-product';
      this.toProduct.setAttribute('data-qv-3d', '');
      this.toProduct.setAttribute('href', this.q('[data-qv-studio]').getAttribute('href') || window.vdbrcSettingProductUrl(this.handle));
      this.toProduct.setAttribute('aria-label', 'View this ring in 3D on the product page');
      this.toProduct.innerHTML = '<img alt="" width="32" height="32">';

      this.buildSliderUi(media);
      this.placeMediaButtons();
    }

    buildSliderUi(media) {
      var ui = this.q('[data-qv-slider-ui]');
      var html = '';
      var hasVideo = media.some(function (m) { return m.media_type !== 'image'; });
      if (hasVideo) {
        html +=
          '<div class="vdbrc-qv__tabs">' +
          '<button type="button" class="vdbrc-qv__tab is-active" data-qv-tab="image" aria-label="Photos"><img src="' + this.dataset.iconPhoto + '" alt="" width="16" height="16"></button>' +
          '<button type="button" class="vdbrc-qv__tab" data-qv-tab="video" aria-label="Video"><img src="' + this.dataset.iconVideo + '" alt="" width="16" height="16"></button>' +
          '</div>';
      }
      if (media.length > 1) {
        html +=
          '<button type="button" class="vdbrc-qv__nav vdbrc-qv__nav--prev" data-qv-nav="prev" aria-label="Previous"><img src="' + this.dataset.iconPrev + '" alt="" width="16" height="16"></button>' +
          '<button type="button" class="vdbrc-qv__nav vdbrc-qv__nav--next" data-qv-nav="next" aria-label="Next"><img src="' + this.dataset.iconNext + '" alt="" width="16" height="16"></button>' +
          '<div class="vdbrc-qv__dots" aria-hidden="true">';
        for (var i = 0; i < media.length; i++) html += '<span class="vdbrc-qv__dot' + (i === 0 ? ' is-active' : '') + '"></span>';
        html += '</div>';
      }
      ui.innerHTML = html;
    }

    placeMediaButtons() {
      if (!this.toProduct) return;
      var img = this.toProduct.querySelector('img');
      if (this.mqDesktop.matches) {
        var first = this.q('[data-qv-gallery]').firstElementChild;
        if (first) first.appendChild(this.toProduct);
        img.src = this.getAttribute('data-icon-3d');
      } else {
        this.q('[data-qv-slider-ui]').appendChild(this.toProduct);
        img.src = this.getAttribute('data-icon-3d-mobile');
      }
    }

    currentSlide() {
      var g = this.q('[data-qv-gallery]');
      return g.clientWidth ? Math.round(g.scrollLeft / g.clientWidth) : 0;
    }

    slide(dir) {
      var g = this.q('[data-qv-gallery]');
      var n = g.children.length;
      if (!n) return;
      var i = (this.currentSlide() + dir + n) % n;
      g.scrollTo({ left: i * g.clientWidth, behavior: 'smooth' });
    }

    goToKind(kind) {
      var g = this.q('[data-qv-gallery]');
      var tiles = Array.prototype.slice.call(g.children);
      var i = tiles.findIndex(function (t) { return t.getAttribute('data-kind') === kind; });
      if (i >= 0) g.scrollTo({ left: i * g.clientWidth, behavior: 'smooth' });
    }

    onGalleryScroll() {
      var i = this.currentSlide();
      this.dialog.querySelectorAll('.vdbrc-qv__dot').forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
      });
      var tile = this.q('[data-qv-gallery]').children[i];
      var kind = tile ? tile.getAttribute('data-kind') : 'image';
      this.dialog.querySelectorAll('[data-qv-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-qv-tab') === kind);
      });
    }

    toggleAcc(head, forceOpen) {
      var body = document.getElementById(head.getAttribute('aria-controls'));
      var open = forceOpen === true ? true : head.getAttribute('aria-expanded') !== 'true';
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
    }

    openDescription() {
      var acc = this.q('[data-qv-acc-description]');
      if (!acc) return;
      var head = acc.querySelector('[data-qv-acc-head]');
      this.toggleAcc(head, true);
      acc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    /* ---------- add to cart (same line as the ring page's ADD TO CART, default values) ---------- */
    cartProperties(handle) {
      var props = {};
      var data = typeof window.vdbrcSettingData === 'function' ? window.vdbrcSettingData(handle) : null;
      var options = (data && data.option_data) || [];
      var platinum = false;
      options.forEach(function (o) {
        var label = norm(o.label);
        var value = norm(o.selected);
        if (!label || !value || value === '-') return;
        props[label] = value;
        if (label === 'Metal' && /platinum/i.test(value)) platinum = true;
      });
      if (platinum) delete props.Color;

      props['Ring Size'] = FIRST_RING_SIZE;

      var params = vdbrcCurrentParams();
      var stock = params.get('labgrown_stock_num') || params.get('natural_stock_num') || '';
      if (stock) {
        params.set('ring-handle', handle);
        params.set('steps', 'settings');
        params.set('review', 'true');
        params.delete('change_flow');
        props['_Review URL'] = vdbrcBuildUrl(rootUrl() + 'products/' + handle, params);
      }
      props['_Pair ID'] = handle + '|' + stock;
      props['_Line Role'] = 'Setting';
      return props;
    }

    async addToCart(button) {
      if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding to cart…';
      var err = this.q('[data-qv-error]');
      err.hidden = true;
      var handle = this.handle;
      var routes = window.routes;
      try {
        var product = await fetchProduct(handle);
        var variant = (product.variants || []).find(function (v) { return v.available; });
        if (!variant) throw new Error('This ring is sold out.');
        if (typeof vdbrcCartContainsVariant === 'function' && await vdbrcCartContainsVariant(variant.id)) {
          if (window.isRedirectToCartPage) {
            window.location.href = routes.cart_url;
            return;
          }
          await vdbrcOpenUpdatedCartDrawer();
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = 'Add to cart';
          return;
        }
        var props = this.cartProperties(handle);

        var cartRes = await fetch(routes.cart_url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        var cart = await cartRes.json().catch(function () { return null; });
        var existing = cart && (cart.items || []).find(function (it) {
          var p = it.properties || {};
          return p['_Pair ID'] === props['_Pair ID'] && p['_Line Role'] === props['_Line Role'];
        });

        var url;
        var payload;
        if (existing && Number(existing.variant_id) === Number(variant.id)) {
          url = routes.cart_change_url + '.js';
          payload = { id: existing.key, quantity: 1, properties: props };
        } else {
          if (existing) {
            await this.postJson(routes.cart_change_url + '.js', { id: existing.key, quantity: 0 });
          }
          url = routes.cart_add_url + '.js';
          payload = { id: Number(variant.id), quantity: 1, properties: props };
        }
        await this.postJson(url, payload);
        if (window.isRedirectToCartPage) {
          window.location.href = routes.cart_url;
          return;
        }
        await vdbrcOpenUpdatedCartDrawer();
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add to cart';
      } catch (e) {
        err.textContent = (e && e.message) || 'Something went wrong while adding to cart.';
        err.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add to cart';
      }
    }

    /* The 3D stage lives in the first tile while open, so it must go back to the media box before the gallery is rebuilt. */
    parkThreeDStage() {
      var stage = this.q('[data-qv-3d-stage]');
      var media = this.q('.vdbrc-qv__media');
      if (stage && media && stage.parentNode !== media) media.appendChild(stage);
    }

    hideThreeD() {
      this.threeDToken = (this.threeDToken || 0) + 1;
      this.threeDBusy = false;
      this.dialog.classList.remove('is-3d', 'is-3d-loading');
      this.parkThreeDStage();
      var error = this.q('[data-qv-3d-error]');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      this.placeMediaButtons();
    }

    toggleThreeD() {
      if (this.threeDBusy) return;
      if (this.dialog.classList.contains('is-3d')) {
        this.hideThreeD();
        return;
      }
      this.openThreeD();
    }

    async openThreeD() {
      var token = (this.threeDToken || 0) + 1;
      this.threeDToken = token;
      this.threeDBusy = true;
      var error = this.q('[data-qv-3d-error]');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      var gallery = this.q('[data-qv-gallery]');
      var firstTile = gallery && gallery.firstElementChild;
      var stage = this.q('[data-qv-3d-stage]');
      if (stage && firstTile) firstTile.appendChild(stage);
      if (gallery && !this.mqDesktop.matches) gallery.scrollTo({ left: 0, behavior: 'smooth' });
      /* Hide the previous ring before the browser paints, then keep the loader up until the new model is ready. */
      this.dialog.classList.add('is-3d', 'is-3d-loading');
      if (window.player) {
        disposeThreeDViewer();
        replaceThreeDCanvas();
      }
      if (this.toProduct) this.toProduct.setAttribute('aria-pressed', 'true');

      try {
        var product = typeof window.vdbrcLoadSettingModel === 'function'
          ? await window.vdbrcLoadSettingModel(this.handle)
          : (typeof window.vdbrcSettingData === 'function' ? window.vdbrcSettingData(this.handle) : null);
        if (token !== this.threeDToken || this.state !== 'open') return;

        if (!product) throw new Error('Couldn’t load the 3D model.');
        var glbs = pickSettingGlbs(product);
        if (!glbs) throw new Error('3D view isn’t available for this setting.');

        await this.ensureThreeDViewer();
        if (token !== this.threeDToken || this.state !== 'open') return;

        await renderSettingModel(product, glbs);
        if (token !== this.threeDToken || this.state !== 'open') return;
        this.dialog.classList.remove('is-3d-loading');
        this.threeDKey = this.handle + '|' + glbs.head + '|' + glbs.shank;
      } catch (e) {
        if (token !== this.threeDToken || this.state !== 'open') return;
        this.dialog.classList.remove('is-3d', 'is-3d-loading');
        this.parkThreeDStage();
        if (this.toProduct) this.toProduct.setAttribute('aria-pressed', 'false');
        this.placeMediaButtons();
        if (error) {
          error.textContent = (e && e.message) || 'Couldn’t load the 3D model.';
          error.hidden = false;
        }
      } finally {
        if (token === this.threeDToken) this.threeDBusy = false;
      }
    }

    ensureThreeDViewer() {
      if (window.player && window.three_d_static_data) return Promise.resolve();
      window.three_d_static_data = window.three_d_static_data || SETTING_3D_MATERIALS;
      var viewerSrc = this.getAttribute('data-viewer-src');
      var webglSrc = this.getAttribute('data-webgl-src');
      return loadScript(viewerSrc).then(function () {
        return loadScript(webglSrc);
      });
    }

    async postJson(url, payload) {
      var res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      var data = await res.json().catch(function () { return null; });
      if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
      return data;
    }
  }

  customElements.define('vdbrc-quick-view', VdbrcQuickView);
})();
